module.exports = __webpack_public_path__ + "img/zp.8e2bdde7.png";